import { controllers } from '../Controllers';
import { loadData, UserDataProvider } from '../../Core/UserDataProvider';
import { GOOGLE_CLIENT_ID } from './tokes';

// ⚠️ REPLACE WITH YOUR ACTUAL CLIENT ID

declare global {
  interface Window {
    google: any;
  }
}

class AdvancedGoogleSignInModel {
  private isInitialized = false;

  // Initialize Google
  configure = async () => {
    if (this.isInitialized) return;

    // Load Google script
    if (!window.google) {
      await new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.onload = () => resolve();
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    this.isInitialized = true;
  };

  // DIRECT SIGN-IN - One click, Google opens immediately
  signIn = async () => {
    await this.configure();

    return new Promise((resolve, reject) => {
      // Initialize Google with callback
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: async (response: any) => {
          try {
            const result = await this.handleResponse(response);
            resolve(result);
          } catch (error) {
            reject(error);
          }
        }
      });

      // Create invisible button and click it immediately
      const div = document.createElement('div');
      div.style.position = 'fixed';
      div.style.top = '-1000px';
      document.body.appendChild(div);

      window.google.accounts.id.renderButton(div, {
        theme: 'filled_blue',
        size: 'large'
      });

      // Auto-click the Google button
      setTimeout(() => {
        const btn = div.querySelector('[role="button"]') as HTMLElement;
        if (btn) btn.click();
        
        // Cleanup
        setTimeout(() => document.body.removeChild(div), 1000);
      }, 100);

      // Timeout
      setTimeout(() => reject(new Error('Timeout')), 30000);
    });
  };

  // Handle Google response
  handleResponse = async (response: any) => {
    if (!response.credential) {
      throw new Error('No credential');
    }

    // Decode user info
    const payload = JSON.parse(atob(response.credential.split('.')[1]));
    const userInfo = {
      email: payload.email,
      name: payload.name,
      picture: payload.picture
    };

    // Send to backend
    const backendResponse = await loadData(UserDataProvider.googleAuthorization, {
      token: response.credential
    });

    // Login
    if (backendResponse.data?.userToken) {
      controllers().auth.login(backendResponse.data.userToken);
    }

    return {
      success: true,
      userInfo,
      data: backendResponse.data
    };
  };

  signOut = async () => {
    if (window.google?.accounts) {
      window.google.accounts.id.disableAutoSelect();
    }
  };

  getErrorMessage = (error: Error) => error.message || 'Sign-in failed';
}

export { AdvancedGoogleSignInModel };